'use client';

import { useEffect, useRef, useState } from 'react';

declare global {
  interface Window {
    hbspt: any;
  }
}
const HubSpotForm = () => {
  const [loading, setLoading] = useState(true);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/46813826.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    const observer = new MutationObserver(() => {

      const iframe = containerRef.current?.querySelector('iframe');

      if (iframe) {
        iframe.addEventListener(
          'load',
          () => {
            setTimeout(() => {
              setLoading(false);
            }, 1000);
          },
          { once: true }
        );
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="grid grid-cols-1 w-full justify-start items-center ">
      {loading && (
        <div className="w-full flex items-center justify-center bg-transparent">
          <div className="w-8 h-8 border-4 border-gray-300 border-t-matco rounded-full animate-spin"></div>
          <p className="ml-3 mt-3">Cargando formulario...</p>
        </div>
      )}

      <div
        ref={containerRef}
        className={`hs-form-frame w-full ${loading ? 'invisible absolute' : 'visible static'}`}
        data-region="na1"
        data-form-id="81433cf4-4379-4199-a246-908136c86df0"
        data-portal-id="46813826"
      />
    </div>
  );
};

export default HubSpotForm;
